export default __webpack_public_path__ + "static/media/primaafp2.78057bed.jpg";